export default __webpack_public_path__ + "static/cta-img-2-3471191bbbd8778ccbcd8ec035fe7ccf.jpg";